/**
 * SeeMe Tab System
 * Lightweight vanilla JS for tab switching.
 *
 * Usage — add data-tab to buttons inside a .tabs container,
 * and data-tab-content to the corresponding panels:
 *
 *   <div class="tabs">
 *       <button class="tabs-button tabs-button--active" data-tab="one">One</button>
 *       <button class="tabs-button" data-tab="two">Two</button>
 *   </div>
 *   <div class="tab-content tab-content--active" data-tab-content="one">...</div>
 *   <div class="tab-content" data-tab-content="two">...</div>
 *
 * Panels are the [data-tab-content] elements under the .tabs container's parent, siblings
 * or wrapped in a div, less any nested inside another panel there: a tab group inside a
 * panel (a transcript's tabs in a list row) keeps its own active panel.
 * Fires a "tab-changed" CustomEvent on the .tabs container with detail: { tab: name }.
 */

(function () {
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tab]');
        if (!btn) return;

        var tabs = btn.closest('.tabs');
        if (!tabs) return;

        e.preventDefault();

        var name = btn.getAttribute('data-tab');

        // Toggle active button
        tabs.querySelectorAll('.tabs-button').forEach(function (b) {
            b.classList.toggle('tabs-button--active', b === btn);
        });

        // Toggle active content — this group's panels under the .tabs container's parent,
        // skipping a nested group's panels (those inside another panel under the same parent)
        var parent = tabs.parentNode;
        var panels = Array.prototype.filter.call(parent.querySelectorAll('[data-tab-content]'), function (panel) {
            var outer = panel.parentElement.closest('[data-tab-content]');
            // `parent` is itself a panel when this group sits directly inside an outer one.
            return !outer || outer === parent || !parent.contains(outer);
        });
        panels.forEach(function (panel) {
            panel.classList.toggle('tab-content--active', panel.getAttribute('data-tab-content') === name);
        });

        // Re-trigger autoresize on textareas that were hidden
        var activePanel = panels.filter(function (panel) {
            return panel.getAttribute('data-tab-content') === name;
        })[0];
        if (activePanel) {
            activePanel.querySelectorAll('textarea[data-autoresize]').forEach(function (ta) {
                ta.style.height = 'auto';
                var cs = getComputedStyle(ta);
                var border = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
                ta.style.height = (ta.scrollHeight + border) + 'px';
            });
        }

        // Dispatch event
        tabs.dispatchEvent(new CustomEvent('tab-changed', { detail: { tab: name }, bubbles: true }));
    });
})();
